<template>
<div id="entry-view">
  <div class="vx-col w-full mb-base">
    <vx-card ref="infoCard" :title="statementFullName" title-color="black">
      <vs-row vs-type="flex" vs-justify="flex-end">

        <vs-col v-if="qpEngineeringApprovalEnabled" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
          <!-- QPEngineering enabled -->
          <!-- Approval + Rejection by Geo Corpo -->
          <vs-button v-if="isSubmitted && !isApproved && isConsolidator && (isApprovedByEngineering || !requiresEngineeringApproval) && isLatestVersion"  type="border" class="mr-3"  @click="openApprovalConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.ApprovalShort')">{{ $t('MRMR.Statement.ApprovalShort') }}</vs-button>
          <vs-button v-if="isSubmitted && isConsolidator && (isApprovedByEngineering || !requiresEngineeringApproval) && isLatestVersion" type="border" class="mr-3" @click="openRejectPrompt" v-b-tooltip.hover :title="$t('MRMR.Statement.RejectShort')">{{ $t('MRMR.Statement.RejectShort') }}</vs-button>

          <!-- Approval + Rejection by QP Engineering -->
          <vs-button v-if="qpEngineeringApprovalEnabled && isSubmitted && isQpEngineering && !isApprovedByEngineering && requiresEngineeringApproval && isLatestVersion"  type="border" class="mr-3"  @click="openEngineeringApprovalConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.ApprovalShort')">{{ $t('MRMR.Statement.ApprovalShort') }}</vs-button>
          <vs-button v-if="qpEngineeringApprovalEnabled && isSubmitted && isQpEngineering && !isApprovedByEngineering && requiresEngineeringApproval && !isApproved && isLatestVersion" type="border" class="mr-3" @click="openRejectPrompt" v-b-tooltip.hover :title="$t('MRMR.Statement.RejectShort')">{{ $t('MRMR.Statement.RejectShort') }}</vs-button>

          <vs-button v-if="canPromoteVersion" type="border" class="mr-3" @click="openPromoteVersionPrompt" v-b-tooltip.hover :title="$t('MRMR.Statement.PromoteVersionTooltip')">{{ $t('MRMR.Statement.PromoteVersionTitle') }}</vs-button>
          <vs-button type="border"  color="danger" @click="returnToList" v-b-tooltip.hover :title="$t('Cancel')">{{ $t('Cancel') }}</vs-button>
        </vs-col>

        <vs-col v-else vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
          <!-- QPEngineering disabled -->
          <!-- Approval + Rejection by Geo Corpo -->
          <vs-button v-if="isSubmitted && !isApproved && isConsolidator && isLatestVersion"  type="border" class="mr-3"  @click="openApprovalConfirm" v-b-tooltip.hover :title="$t('MRMR.Statement.ApprovalShort')">{{ $t('MRMR.Statement.ApprovalShort') }}</vs-button>
          <vs-button v-if="isSubmitted && isConsolidator && isLatestVersion" type="border" class="mr-3" @click="openRejectPrompt" v-b-tooltip.hover :title="$t('MRMR.Statement.RejectShort')">{{ $t('MRMR.Statement.RejectShort') }}</vs-button>

          <vs-button v-if="canPromoteVersion" type="border" class="mr-3" @click="openPromoteVersionPrompt" v-b-tooltip.hover :title="$t('MRMR.Statement.PromoteVersionTooltip')">{{ $t('MRMR.Statement.PromoteVersionTitle') }}</vs-button>
          <vs-button type="border"  color="danger" @click="returnToList" v-b-tooltip.hover :title="$t('Cancel')">{{ $t('Cancel') }}</vs-button>
        </vs-col>

      </vs-row>
      <vs-tabs v-model="selectedTab">
        <vs-tab value="0" :label="$t('MRMR.Statement.Tab1')" icon-pack="feather" icon="icon-settings">
          <div class="p-6">
          <vs-row class="mb-3">
              <vs-col vs-w="6" class="mr-5">
                 <validated-input
                    :label="$t('MRMR.Statement.Project')"
                    v-model="projectName"
                    :disabled="true"
                  ></validated-input>
              </vs-col>
              <vs-col vs-w="5">
                <validated-input
                    :label="$t('MRMR.Statement.Period')"
                    v-model="periodName"
                    :disabled="true"
                  ></validated-input>
              </vs-col>
            </vs-row>
            <vs-row class="mb-3">
              <vs-col vs-w="6" class="mr-5">
                <validated-input
                    :label="$t('MRMR.Statement.QPEngineering')"
                    v-model="qpEngineering"
                    :disabled="true"
                  ></validated-input>
              </vs-col>
              <vs-col vs-w="5">
                <validated-input
                  :label="$t('MRMR.Statement.QPGeology')"
                  v-model="qpGeology"
                  :disabled="true"
                ></validated-input>
              </vs-col>
            </vs-row>
            <vs-row class="mb-3">
                <vs-col vs-w="6" class="mr-5">
                  <vs-row class="mb-3">
                    <vs-col vs-w="2" class="mr-5">
                      <validated-input
                        :label="$t('MRMR.Statement.Ownership')"
                        v-model="ownership"
                        :disabled="true"
                      ></validated-input>
                    </vs-col>
                     <vs-col vs-w="5" >
                      <form-label>{{$t('MRMR.Statement.CoreLoggingDatabaseClosureDate')}}</form-label><br />
                      <span class="pl-2 pt-5"> {{ coreLoggingDatabaseClosureDate | toDate }}</span>
                    </vs-col>
                  </vs-row>
                  <vs-row v-if="metallurgicalRecoveries.length > 0">
                    <form-label>{{$t('MRMR.Statement.MetallurgicalRecovery')}}</form-label>
                  </vs-row>
                  <vs-row class="mb-3" v-if="metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.OpenPit).length > 0">
                    <vs-col vs-w="2" class="pr-1 mt-10">
                      {{ $t("MRMR.MiningType." + miningTypeEnum.OpenPit) }}
                    </vs-col>
                    <vs-col vs-w="10" class="pr-1">
                      <span class="metallurgical-recovery pr-2" v-for="(item, index) in metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.OpenPit)" v-bind:key="index">
                        <span>
                          <validated-input :label="getElementName(item.element)"
                              v-model="item.percentage" :disabled="true"></validated-input>
                          <vs-checkbox v-model="item.nonApplicable" :disabled="true" class="mt-2">{{ $t('NA') }}</vs-checkbox>
                        </span>
                      </span>
                    </vs-col>
                  </vs-row>
                  <vs-row class="mb-3" v-if="metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.Underground).length > 0">
                    <vs-col vs-w="2" class="pr-1 mt-10">
                      {{ $t("MRMR.MiningType." + miningTypeEnum.Underground) }}
                    </vs-col>
                    <vs-col vs-w="10" class="pr-1">
                      <span class="metallurgical-recovery pr-2" v-for="(item, index) in metallurgicalRecoveries.filter(_ => _.miningType === miningTypeEnum.Underground)" v-bind:key="index">
                        <span>
                          <validated-input :label="getElementName(item.element)"
                              v-model="item.percentage" :disabled="true">
                            </validated-input>
                          <vs-checkbox v-model="item.nonApplicable" :disabled="true" class="mt-2">{{ $t('NA') }}</vs-checkbox>
                        </span>
                      </span>
                    </vs-col>
                  </vs-row>
                  <vs-row class="mb-3">
                    <vs-col vs-w="12">
                      <form-label>{{$t('MRMR.Statement.Notes')}} </form-label>
                      <vs-textarea
                        v-model="notes"
                        v-if="selectedNotesVersion === statementVersion"
                        :disabled="true"
                        class="w-full notes-mb-none"
                        height="300px"
                        name="notes" />
                      <vs-textarea
                        v-model="selectedPreviousVersionNote"
                        v-else
                        :disabled="true"
                        class="w-full notes-mb-none notes-read-only"
                        height="300px"/>
                    </vs-col>
                    <vs-row>
                      <vs-tabs alignment="right" v-model="selectedNoteIndex" >
                        <vs-tab  v-for="(note, index) in allNoteVersions" :key="index" :label="String(note.version)" @click="onNotesVersionClicked(note.version)" v-b-tooltip.hover :title="$t('MRMR.Statement.Notes') + ' v' + note.version">
                        </vs-tab>
                      </vs-tabs>
                    </vs-row>
                  </vs-row>
                </vs-col>
                <vs-col vs-w="5">
                  <vs-row class="mb-3">
                    <vs-col vs-w="3" class="mr-5">
                       <validated-input
                        :label="$t('MRMR.Statement.Device')"
                        v-model="device"
                        :disabled="true"
                      ></validated-input>
                    </vs-col>
                    <vs-col vs-w="3" >
                      <validated-input
                        :label="$t('MRMR.Statement.FXRate')"
                        v-model="fxRate"
                        :disabled="true"
                      ></validated-input>
                    </vs-col>
                    <vs-col vs-w="3" vs-type="flex" vs-align="center">
                      <form-label class="mt-6 usd-equivalent">= 1$ USD</form-label>
                    </vs-col>
                  </vs-row>
                  <vs-divider position="left-center" class="mb-0">{{ $t('MRMR.ElementPrice.Title') }}</vs-divider>
                  <vs-row>
                    <vs-col class="tableCol pr-5 mr-5 border-right" vs-w="6">
                      <vs-row>
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="10" >
                          <span>{{ getMetalPricesName(resourceCategoryEnum.Reserve) }}</span>
                        </vs-col>
                      </vs-row>
                      <vs-row>
                        <vs-list>
                          <vs-list-item v-for="(listItem, index) in reserveElementPrices" :key="index" :title="$t('Element.' + listItem.element) + ' - ' + listItem.price + ' $'" />
                        </vs-list>
                      </vs-row>
                    </vs-col>
                    <vs-col class="tableCol" vs-w="5">
                      <vs-row>
                        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="left" vs-w="10" >
                          <span>{{ getMetalPricesName(resourceCategoryEnum.Resource) }}</span>
                        </vs-col>
                      </vs-row>
                      <vs-row>
                        <vs-list  >
                          <vs-list-item v-for="(listItem, index) in resourceElementPrices" :key="index" :title="$t('Element.' + listItem.element) + ' - ' + listItem.price + ' $'" />
                        </vs-list>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                  <vs-divider v-if="submittedBy" position="left-center" class="mb-3">{{ $t('MRMR.Statement.Submission') }} </vs-divider>
                  <vs-row v-if="submittedBy" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.SubmittedBy') }} : </span><span class="ml-2">{{ submittedBy }}</span>
                  </vs-row>
                  <vs-row v-if="submittedBy" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.SubmissionDate') }} : </span><span class="ml-2">{{ submissionDate | toLocalDateTime }}</span>
                  </vs-row>
                  <vs-divider v-if="engineeringApprovedBy" position="left-center" class="mb-3">{{ $t('MRMR.Statement.EngineeringApproval') }} </vs-divider>
                  <vs-row v-if="engineeringApprovedBy" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.ApprovedBy') }} : </span><span class="ml-2">{{ engineeringApprovedBy }}</span>
                  </vs-row>
                  <vs-row v-if="engineeringApprovalDate" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.ApprovalDate') }} : </span><span class="ml-2">{{ engineeringApprovalDate | toLocalDateTime }}</span>
                  </vs-row>
                  <vs-divider v-if="approvedBy" position="left-center" class="mb-3">{{ $t('MRMR.Statement.Approbation') }} </vs-divider>
                  <vs-row v-if="approvedBy" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.ApprovedBy') }} : </span><span class="ml-2">{{ approvedBy }}</span>
                  </vs-row>
                  <vs-row v-if="approvedBy" class="mb-3">
                    <span class="font-semibold">{{ $t('MRMR.Statement.ApprovalDate') }} : </span><span class="ml-2">{{ approvalDate | toLocalDateTime }}</span>
                  </vs-row>
                </vs-col>
              </vs-row>
          </div>
        </vs-tab>
        <vs-tab value="1" :label="$t('MRMR.Statement.Tab2')" icon-pack="feather" icon="icon-list">
          <statement-lines
            :entries="statementEntries"
            :previousStatements="previousStatements"
            :readOnly="true"
             @onComparisonStatementChange="comparisonStatementChange"
          />

        </vs-tab>
        <vs-tab value="2" :label="$t('MRMR.Statement.Tab3')" icon-pack="feather" icon="icon-trending-up">
          <statement-comparison
          :readOnly="true"
           :selectedStatement="selected"
            @onComparisonStatementChange="comparisonStatementChange" />
        </vs-tab>
        <!-- <vs-tab value="3" :label="$t('MRMR.Statement.Detailed')" icon-pack="feather" icon="icon-trending-up">
          <detailed-report
          :readOnly="true"
           :statementAId="selected.Id"
           :statementBId="comparisonStatementId" />
        </vs-tab> -->
      </vs-tabs>
    </vx-card>
  </div>
  <vs-prompt
    :title="$t('MRMR.Statement.Reject')"
    @cancel="cancelReject"
    @accept="rejectStatement"
    @close="cancelReject"
    :active.sync="activePrompt">
    <div class="con-exemple-prompt">
      <span>{{ $t('MRMR.Statement.ConfirmReject')}}</span>
      <vs-input :placeholder="$t('MRMR.Statement.Reason')" :vs-placeholder="$t('MRMR.Statement.Reason')" v-model="reason" class="mt-3 w-full" />
    </div>
  </vs-prompt>
  <vs-prompt
    :title="$t('MRMR.Statement.PromoteVersionTitle')"
    @cancel="cancelPromoteVersion"
    @accept="promoteVersion"
    @close="cancelPromoteVersion"
    :active.sync="activePromoteVersionPrompt">
    <div class="con-exemple-prompt">
      <vs-row class="mb-5">
        <span>{{ $t('MRMR.Statement.ConfirmPromoteVersion')}}</span>
      </vs-row>
      <form-label>{{$t('MRMR.Statement.Notes')}}</form-label>
      <ValidationProvider :name="$t('MRMR.Statement.Notes')" rules="required" v-slot="{ errors }">
        <vs-textarea
          v-model="selectedComments"
          class="w-full"
          height="300px"
          name="comments" />
        <validation-message>{{ errors[0] }}</validation-message>
      </ValidationProvider>
    </div>
  </vs-prompt>
</div>
</template>

<script>

import router from '../../../../router'
// import draggable from 'vuedraggable'
import StatementLines from './components/StatementLines.vue'
import StatementComparison from './components/StatementComparison.vue'
import moduleMRMR from "../store/moduleMRMR.js";
import ResourceCategoryEnum from "../ResourceCategoryEnum.js";
import {
  ValidatedInput,
  FormLabel
} from "../../../shared/components";
import MiningTypeEnum from "../MiningTypeEnum.js";
import featureFlagsService from '@/app/shared/services/featureFlagsService.js'
import features from "@/app/shared/AppFeatures.js"

export default {
  components: {
    ValidatedInput,
    StatementComparison,
    StatementLines,
    FormLabel
  },
  data() {
    return {
      activePrompt:false,
      selectedProjectId: null,
      selected : null,
      statementEntries: [],
      previousStatements: [],
      selectedTab: 0,
      statementId: 0,
      reason: '',
      isLatestVersion: true,
      selectedComments: null,
      activePromoteVersionPrompt: false,
      comparisonStatementId: 0,
      selectedNotesVersion: 1,
      selectedNoteIndex: 0,
      resourceCategoryEnum : ResourceCategoryEnum,
      miningTypeEnum: MiningTypeEnum
    };
  },
  computed: {
    qpEngineerModel() {
      const list = this.$store.state.mrmr.qps;
      return list.find(_ => _.id === this.selected.engineerQPId);
    },
    qpGeologyhModel() {
      const list = this.$store.state.mrmr.qps;
      return list.find(_ => _.id === this.selected.geologistQPId);
    },
    statementFullName() {
      if (this.selected) {
        return `${this.selected.project.name} - ${this.selected.period.name} - v${this.selected.version}`;
      }
      return "";
    },
    projectName() {
      if (this.selected) {
        return this.selected.project.name;
      } else {
        return "";
      }
    },
    periodName() {
      if (this.selected) {
        return this.selected.period.name;
      } else {
        return "";
      }
    },
    qpGeology() {
      if (this.selected) {
        if (this.qpGeologyModel) {
          return this.qpGeologyModel.email;
        }
        return this.selected.qpGeology;
      } else {
        return "";
      }
    },
    qpEngineering() {
      if (this.selected) {
        if (this.qpEngineerModel) {
          return this.qpEngineerModel.email;
        }
        return this.selected.qpEngineering;
      } else {
        return "";
      }
    },
    ownership() {
      if (this.selected) {
        return this.selected.ownership;
      } else {
        return "";
      }
    },
    coreLoggingDatabaseClosureDate() {
      if (this.selected) {
        return this.selected.coreLoggingDatabaseClosureDate;
      } else {
        return "";
      }
    },
    notes() {
      if (this.selected) {
        return this.selected.notes;
      } else {
        return "";
      }
    },
    device() {
      if (this.selected) {
        return this.$t("MRMR.Devices." + this.selected.device);
      } else {
        return "";
      }
    },
    fxRate() {
      if (this.selected) {
        return this.selected.fxRate;
      } else {
        return "";
      }
    },
    submittedBy() {
      if (this.selected) {
        return this.selected.submittedBy;
      } else {
        return "";
      }
    },
    submissionDate() {
      if (this.selected) {
        return this.selected.submissionDate;
      } else {
        return "";
      }
    },
    approvedBy() {
      if (this.selected) {
        return this.selected.approvedBy;
      } else {
        return "";
      }
    },
    approvalDate() {
      if (this.selected) {
        return this.selected.approvalDate;
      } else {
        return "";
      }
    },
    engineeringApprovedBy() {
      if (this.selected) {
        return this.selected.engineeringApprovedBy;
      } else {
        return "";
      }
    },
    engineeringApprovalDate() {
      if (this.selected) {
        return this.selected.engineeringApprovalDate;
      } else {
        return "";
      }
    },
    sortedElementPrices() {
      if (this.selected) {
        const list =   this.selected.elementPrices;
        return list.sort((a, b) => { return (a.element < b.element) ? -1 : 1 });
      } else {
        return [];
      }
    },
    metallurgicalRecoveries() {
      if (this.selected) {
        return this.selected.metallurgicalRecoveries;
      } else {
        return [];
      }
    },
    resourceElementPrices() {
      return this.sortedElementPrices.filter(o => o.resourceCategory === ResourceCategoryEnum.Resource);
    },
    reserveElementPrices() {
      return this.sortedElementPrices.filter(o => o.resourceCategory === ResourceCategoryEnum.Reserve);
    },
    isConsolidator() {
      return this.$auth.isInRole("MRMRConsolidation") || this.$auth.isInRole("Admin");
    },
    isQpEngineering() {
      // make sure qpEngineering is not null
      return this.qpEngineering && this.qpEngineering.toLowerCase()  === this.$auth.getUser().username.toLowerCase();
    },
    canPromoteVersion() {
      return (this.$auth.isInRole("MRMRCollaborators") || this.$auth.isInRole("Admin")) && !this.isLatestVersion;
    },
    isSubmitted() {
      if (this.selected) {
        return this.selected.isSubmitted;
      } else {
        return false;
      }
    },
    isApproved() {
      if (this.selected) {
        return this.selected.isApproved;
      } else {
        return false;
      }
    },
    isApprovedByEngineering() {
      if (this.selected) {
        return this.selected.isApprovedByEngineering;
      } else {
        return false;
      }
    },
    requiresEngineeringApproval() {
      if (this.selected) {
        return this.selected.requiresEngineeringApproval;
      } else {
        return false;
      }
    },

    selectedPreviousVersionNote() {
      const previousNote = this.versionsNotes.find(o => o.version === this.selectedNotesVersion);
      if (previousNote !== null && previousNote !== undefined) {
        return previousNote.notes;
      } else
        return '';
    },
    allNoteVersions() {
      const allVersions = this.versionsNotes.map(obj => {
        return {
          version : obj.version,
          name : 'v' + obj.version
        }
      });
      allVersions.push({
        version : this.statementVersion,
        name : 'v' + this.statementVersion
      });

      return allVersions;
    },
    versionsNotes() {
      const periodId = this.selected ? this.selected.period.id : undefined;
      return this.previousStatements.filter(o => o.mrmrStatementPeriodId === periodId).map(obj => {
        return {
          id: obj.id,
          version : obj.version,
          name : 'v' + obj.version,
          notes : obj.notes
        }
      });
    },
    statementVersion() {
      return this.selected ? this.selected.version : undefined;
    },
    qpEngineeringApprovalEnabled() {
      if (!features.Geo) return false;
      if (!features.Geo.MRMR) return false;
      return featureFlagsService.isEnabled(features.Geo.MRMR.QpEngineeringApproval);
    }

  },

  mounted() {

    if (this.$store.state.mrmr.statements.length === 0) {
      this.$vs.loading();
      this.$store.dispatch("mrmr/fetchStatementListItems",  this.selectedProjectId).then(() => {
        this.$vs.loading.close();
      });
    }
  },

  created() {
    if (!moduleMRMR.isRegistered) {
      this.$store.registerModule("mrmr", moduleMRMR);
      moduleMRMR.isRegistered = true;
    }

    this.selectedProjectId = Number(this.$store.state.projectId);
    if (this.$route.params.isLatestVersion !== undefined) {
      this.isLatestVersion = this.$route.params.isLatestVersion;
    }
    else {
      this.isLatestVersion = true;
    }

    if (this.$route.params.selectedStatement !== undefined && this.$route.params.selectedStatement !== null) {
      this.statementId = this.$route.params.selectedStatement.id;
      this.refreshModel();
    } else if (this.$route.query.id !== undefined && this.$route.query.id !== null) {
      this.statementId = this.$route.query.id;
      this.refreshModel();
    }
  },
  methods: {
    getMetalPricesName (value) {
      return this.$t("MRMR.MetalPrices." + value);
    },
    comparisonStatementChange(comparisonStatementId) {
      this.comparisonStatementId = comparisonStatementId;
    },
    refreshModel() {
      this.$vs.loading();
      Promise.all([
        this.getCurrentStatement(),
        this.getPreviousStatement()
      ]).finally(() => {
        this.$vs.loading.close();
        this.setDefaultNoteVersionIndex();
      })
    },
    getCurrentStatement() {
      return new Promise((resolve, reject) => {
        this.$cqrsGet("geo/mrmr/statements/getStatement/", { params: { id: this.statementId } }).then((response) => {
          this.selected = response.data.model;
          this.statementEntries = response.data.model.entries;
          resolve(response)
        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message
          });
          reject(error)
        })
      });
    },
    getPreviousStatement() {
      return new Promise((resolve, reject) => {
        this.$cqrsGet("geo/mrmr/statements/FindAllPrevious", { params: { id: this.statementId }}).then((response) => {
          const model = response.data.model;
          if (model !== null) {
            this.previousStatements = model;
          }
          resolve(response)
        }).catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: this.$t("LoadingError"),
            text: error.message
          });
          reject(error)
        })
      });
    },
    returnToList() {
      router.push("/mrmr/statements");
    },
    openRejectPrompt() {
      this.activePrompt = true;
    },
    cancelReject() {
      this.reason = '';
    },
    rejectStatement() {
      if (this.statementId !== null) {
        this.$vs.loading();
        this.$cqrsPost('geo/mrmr/statements/reject/', {
          id : this.statementId,
          reason : this.reason})
          .then((response) => {
            if (response.data.success) {

              this.$vs.notify({
                color: "success",
                title: this.$t("Success"),
                text: this.$t("MRMR.Statement.RejectSuccess")
              });

              this.$vs.loading.close();
              router.push("/mrmr/statements");

            }
          }).catch((error) => {
            this.$notifySaveError(error);
            this.$vs.loading.close();
            console.log(error);
          });
      }
    },
    openApprovalConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('MRMR.Statement.ConfirmApproval'),
        accept: this.approveStatement
      });
    },
    openEngineeringApprovalConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('MRMR.Statement.ConfirmApprovalByEngineering'),
        accept: this.approveStatementByEngineering
      });
    },
    approveStatement() {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/approve', { id: this.statementId })
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              color: "success",
              title: this.$t("Success"),
              text: this.$t("MRMR.Statement.ApprovalSuccess")
            });

            this.$vs.loading.close();
            router.push("/mrmr/statements");

          }
        }).catch((error) => {
          this.$notifySaveError(error);
          this.$vs.loading.close();
          console.log(error);
        });
    },
    approveStatementByEngineering() {
      this.$vs.loading();
      this.$cqrsPost('geo/mrmr/statements/approveByEngineering', { id: this.statementId })
        .then((response) => {
          if (response.data.success) {
            this.$vs.notify({
              color: "success",
              title: this.$t("Success"),
              text: this.$t("MRMR.Statement.ApprovalByEngineeringSuccess")
            });

            this.$vs.loading.close();
            router.push("/mrmr/statements");

          }
        }).catch((error) => {
          this.$notifySaveError(error);
          this.$vs.loading.close();
          console.log(error);
        });
    },
    openPromoteVersionPrompt() {
      this.selectedComments = null;
      this.activePromoteVersionPrompt = true;
    },
    cancelPromoteVersion() {
      this.selectedComments = null;
      this.activePromoteVersionPrompt = false;
    },
    promoteVersion() {
      this.activePromoteVersionPrompt = false;
      this.$cqrsPost('geo/mrmr/statements/promoteVersion/', {
        id : this.statementId,
        notes : this.selectedComments})
        .then(() => {
          this.$notifySuccess(this.$t('MRMR.Statement.PromoteVersionSuccess'));
          router.push("/mrmr/statements");
        });
    },

    setDefaultNoteVersionIndex() {
      const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
      };

      sleep(100).then(() => {
        if (this.statementVersion) {
          this.selectedNoteIndex = this.statementVersion - 1;
          this.selectedNotesVersion = this.statementVersion;
        }
      });

    },
    onNotesVersionClicked(version) {
      this.selectedNotesVersion = version;
    },
    getElementName(element) {
      return this.$t("Element." + element);
    }
  }
};
</script>
<style lang="scss">
  .list-scrollable {
    height:500px;/* or any height you want */
    overflow-y:auto;
  }
  .metallurgical-recovery {
    display: flex;
    float:inline-start;
    width:100px
  }
</style>
